import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './Authcontext';

// Role hierarchy for permissions
const ROLE_PERMISSIONS = {
  SUPERADMIN: ['dashboard', 'users', 'users-add', 'users-edit', 'users-delete', 'mark-attendance', 'mudat', 'profile', 'control-panel', 'questions', 'sales'],
  ADMIN: ['dashboard', 'users', 'users-add', 'users-edit', 'mark-attendance', 'mudat', 'profile', 'questions'],
  EDITOR: ['dashboard', 'users', 'users-add', 'users-edit', 'mark-attendance', 'profile', 'questions'],
  SALES: ['sales'],
  USER: ['profile'],
};

// Check if role has permission
export const hasPermission = (role, permission) => {
  if (!role || !ROLE_PERMISSIONS[role]) return false;
  return ROLE_PERMISSIONS[role].includes(permission);
};

// Get allowed permissions for a role
export const getPermissions = (role) => {
  return ROLE_PERMISSIONS[role] || [];
};

// Protected Route Component
const ProtectedRoute = ({ children, requiredPermission }) => {
  const { isLoggedIn, role, loading } = useAuth();

  // Wait for auth state to load from localStorage before making any redirect decision
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-600"></div>
      </div>
    );
  }

  // Not logged in → redirect to login
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  // SALES role → only sales page
  if (role === 'SALES' && requiredPermission !== 'sales') {
    return <Navigate to="/sales" replace />;
  }

  // USER role → redirect to profile page
  if (role === 'USER' && requiredPermission !== 'profile') {
    return <Navigate to="/profile" replace />;
  }

  // Check permission if required
  if (requiredPermission && !hasPermission(role, requiredPermission)) {
    // Redirect to dashboard if no permission (for admin roles)
    // Redirect to profile if USER
    if (role === 'USER') {
      return <Navigate to="/profile" replace />;
    }
    if (role === 'SALES') {
      return <Navigate to="/sales" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;